@if (contextService.form) {
	<mat-expansion-panel
		[id]="assessableItemId()"
		[@zoomInOnEnter]
		[@zoomOutOnLeave]
		[class.invalid]="itemControl().invalid"
		class="itemPanel twoColorHeader"
		[expanded]="!isExpandable() ? false : expanded()"
		[disabled]="!isExpandable()"
		hideToggle
	>
		<mat-expansion-panel-header (click)="togglePanel()">
			<mat-panel-title (keydown.space)="$event.stopImmediatePropagation()">
				<div class="panelTitleContent">
					<!-- Index, Title, Score, Answer Badge, Expand Button -->
					<div class="panelTitleUpper" [class.compact]="compactLayout()">
						<div class="titleLeft">
							@if (!isExpandButtonHidden()) {
								<button
									class="expandButton"
									mat-icon-button
									color="accent"
									[matTooltip]="
										expanded() ? (T.ASSESSABLE_ITEM_HIDE_INFO | translate) : (T.ASSESSABLE_ITEM_SHOW_INFO | translate)
									"
									matTooltipClass="accent"
									[matTooltipDisabled]="tooltipDisabled"
									appStopPropagation
									(click)="togglePanel()"
									(touchstart)="tooltipDisabled = true"
									[disabled]="!isExpandable()"
								>
									<mat-icon fontIcon="fa-info-circle" fontSet="fad" />
								</button>
							} @else {
								<div class="expandButtonPlaceholder expandButton"></div>
							}
							<span class="groupIndex">
								{{ indexString() }}
							</span>
						</div>
						<div class="titleMiddle">
							<sim-rich-text-editor-view [content]="itemControl().controls.title.value" [@zoomInOnEnter] />
							@if (hideExpansionArea() && note()) {
								<mat-icon
									[matTooltip]="SimUtilityService.stripHtml(note())"
									matTooltipPosition="above"
									matTooltipClass="accent large"
									fontSet="fad"
									fontIcon="fa-info-circle"
									color="accent"
									class="notesInfoIcon"
								/>
							}
							@if (isHintsDialogEnabled()) {
								<button
									mat-icon-button
									color="accent"
									(click)="onOpenHintsDialog.emit()"
									[matTooltip]="T.ASSESSABLE_ITEM_SHOW_PROCEDURE_AND_REASONING | translate"
									matTooltipClass="accent"
								>
									<mat-icon fontSet="fad" fontIcon="fa-file-exclamation" inline />
								</button>
							}
						</div>
						<div class="titleRight" [class.compact]="compactLayout()">
							<!-- Answer Input in compact layout -->
							@if (isAnswerInputInHeader()) {
								<div appStopPropagation class="titleInput" [class.disabled]="disabled()">
									<mat-divider vertical />
									@switch (type()) {
										@case (ChecklistItemType.YesNoOption) {
											<ng-container *ngTemplateOutlet="yesNoItemTemplate()" />
										}
										@case (ChecklistItemType.ThreeStarOption) {
											<ng-container *ngTemplateOutlet="ratingItemTemplate()" />
										}
									}
									<mat-divider vertical />
								</div>
							}
							<ng-container *ngTemplateOutlet="scoreTemplate()" />
							@if (mode() === AssessablePanelMode.View && answerTime() && isInArchive()) {
								<div class="jumpControlWrapper">
									<mat-icon class="timeIcon" fontSet="fas" fontIcon="fa-clock" inline />
									<span class="time">{{ answerTime() | mmss }}</span>
									<mat-divider vertical />
									<button
										mat-icon-button
										color="accent"
										(click)="onTimestampClicked.emit()"
										[matTooltip]="T.SHARED_EXPANSION_CHECKLIST_JUMP_TO_MARKER | translate"
										matTooltipClass="accent"
									>
										<mat-icon fontSet="fad" fontIcon="fa-forward" inline />
									</button>
								</div>
							}
						</div>
					</div>
					<!-- Answer Input -->
					@if (!isAnswerInputInHeader()) {
						<mat-divider class="answerInputHeaderDivider" />
						<div class="panelTitleLower" appStopPropagation>
							<div class="checklistEntryContent" [class.disabled]="disabled()">
								@switch (type()) {
									@case (ChecklistItemType.FreeAnswerOption) {
										<ng-container *ngTemplateOutlet="freeAnswerItemTemplate()" />
									}
									@case (ChecklistItemType.MultipleChoiceOption) {
										<ng-container *ngTemplateOutlet="multipleChoiceItemTemplate()" />
									}
									@case (ChecklistItemType.SingleChoiceOption) {
										<ng-container *ngTemplateOutlet="singleChoiceItemTemplate()" />
									}
									@case (ChecklistItemType.YesNoOption) {
										<ng-container *ngTemplateOutlet="yesNoItemTemplate()" />
									}
									@case (ChecklistItemType.ThreeStarOption) {
										<ng-container *ngTemplateOutlet="ratingItemTemplate()" />
									}
								}
							</div>
						</div>
					}
				</div>
			</mat-panel-title>
		</mat-expansion-panel-header>
		<ng-template matExpansionPanelContent>
			<div class="bottomContent" [@zoomInOnEnter] [class.hidden]="hideExpansionArea()">
				<div class="bottomUpperContent" [class.compact]="compactLayout() && hasMiddleAdditionalContent() && note()">
					<sim-note-area
						[formControl]="itemControl().controls.note"
						[mode]="mode()"
						[inEditMode]="false"
						[canEnterEditMode]="false"
					/>
					@if (!compactLayout() && hasMiddleAdditionalContent() && note()) {
						<mat-divider class="bottomContentDivider" />
					}
					<ng-container *ngTemplateOutlet="middleAdditionalContentTemplate()" />
				</div>
			</div>
		</ng-template>
	</mat-expansion-panel>
}
